// Mock data for the Dev Team Portal

export const dashboardStats = [
  {
    id: 1,
    title: "Total Employees",
    value: "48",
    icon: "👥",
    change: "+5%",
    trend: "up",
  },
  {
    id: 2,
    title: "Active Tasks",
    value: "127",
    icon: "📋",
    change: "+12%",
    trend: "up",
  },
  {
    id: 3,
    title: "Open Tickets",
    value: "23",
    icon: "🎫",
    change: "-8%",
    trend: "down",
  },
  {
    id: 4,
    title: "Completed This Week",
    value: "45",
    icon: "✅",
    change: "+20%",
    trend: "up",
  },
];

export const employees = [
  {
    id: 1,
    fullName: "Mohamed Osman",
    fullNameArabic: "محمد عثمان",
    employeeCode: "3411",
    fingerprintCode: "1602",
    email: "mohamed.osman@absisgy.com",
    phone: "01095902696",
    jobPosition: "Software Engineer",
    title: "Backend Lead",
    branch: "المركز الرئيسي",
  },
  {
    id: 2,
    fullName: "Seif Sameh",
    fullNameArabic: "سيف سامح",
    employeeCode: "3412",
    fingerprintCode: "1606",
    email: "seif.sameh@absisgy.com",
    phone: "01055116099",
    jobPosition: "Software Engineer",
    title: "Frontend Lead",
    branch: "المركز الرئيسي",
  },
  {
    id: 3,
    fullName: "Ammar Moataz",
    fullNameArabic: "عمار معتز",
    employeeCode: "3413",
    fingerprintCode: "1610",
    email: "ammarmoataz10@gmail.com",
    phone: "01143238316",
    jobPosition: "Software Engineer",
    title: "Frontend Developer",
    branch: "المركز الرئيسي",
  },
  {
    id: 4,
    fullName: "Mariam Mostafa",
    fullNameArabic: "مريم مصطفى",
    employeeCode: "3416",
    fingerprintCode: "1611",
    email: "mariam.mostafa@absisgy.com",
    phone: "01282494768",
    jobPosition: "Software Engineer",
    title: "Frontend Developer",
    branch: "المركز الرئيسي",
  },
  {
    id: 5,
    fullName: "Youssef Alaa",
    fullNameArabic: "يوسف علاء",
    employeeCode: "3493",
    fingerprintCode: "1627",
    email: "youssef.alaa@absisgy.com",
    phone: "01270246085",
    jobPosition: "Software Engineer",
    title: "Backend Developer",
    branch: "المركز الرئيسي",
  },
];

export const weekSchedule = [
  {
    id: 1,
    employee: "Mohamed Osman",
    monday: "09:00 - 17:00",
    tuesday: "09:00 - 17:00",
    wednesday: "09:00 - 17:00",
    thursday: "09:00 - 17:00",
    friday: "Off",
    saturday: "09:00 - 14:00",
    sunday: "Off",
  },
  {
    id: 2,
    employee: "Seif Sameh",
    monday: "09:00 - 17:00",
    tuesday: "09:00 - 17:00",
    wednesday: "09:00 - 17:00",
    thursday: "09:00 - 17:00",
    friday: "Off",
    saturday: "09:00 - 14:00",
    sunday: "Off",
  },
  {
    id: 3,
    employee: "Ammar Moataz",
    monday: "09:00 - 17:00",
    tuesday: "09:00 - 17:00",
    wednesday: "09:00 - 17:00",
    thursday: "09:00 - 17:00",
    friday: "Off",
    saturday: "09:00 - 14:00",
    sunday: "Off",
  },
];

export const hrFormData = [
  {
    id: 1,
    code: "4354",
    employeeFingerprint: "1798",
    employee: "أحمد شطالي السيد",
    jobPosition: "مهندس برمجيات",
    branch: "المركز الرئيسي",
    timeOffType: "عاجل بدون راتب",
    reason: "العمل من المنزل",
    startDate: "2026-01-28",
    endDate: "2026-01-28",
    days: 1,
  },
  {
    id: 2,
    code: "3657",
    employeeFingerprint: "1644",
    employee: "كيرلس عادل",
    jobPosition: "مهندس برمجيات",
    branch: "المركز الرئيسي",
    timeOffType: "عاجل بدون راتب",
    reason: "العمل من المنزل",
    startDate: "2026-01-27",
    endDate: "2026-01-27",
    days: 1,
  },
];

export const tickets = [
  {
    id: 1,
    title: "Login page not responsive on mobile",
    description: "The login form overflows on screens smaller than 375px",
    status: "open",
    priority: "high",
    assignee: "Seif Sameh",
    createdBy: "Ahmed Ali",
    createdAt: "2026-01-20",
    category: "Bug",
  },
  {
    id: 2,
    title: "Add dark mode toggle",
    description: "Users want to switch between light and dark themes",
    status: "in-progress",
    priority: "medium",
    assignee: "Ammar Moataz",
    createdBy: "Sara Mohamed",
    createdAt: "2026-01-18",
    category: "Feature",
  },
  {
    id: 3,
    title: "API timeout on large datasets",
    description:
      "The employee export API times out when fetching more than 1000 records",
    status: "open",
    priority: "critical",
    assignee: "Mohamed Osman",
    createdBy: "HR Department",
    createdAt: "2026-01-15",
    category: "Bug",
  },
];

export const ticketComments = [
  {
    id: 1,
    ticketId: 1,
    author: "Ahmed Ali",
    message: "This is affecting our mobile users badly",
    timestamp: "2026-01-20 10:30",
  },
  {
    id: 2,
    ticketId: 1,
    author: "Seif Sameh",
    message: "I will look into this today and fix the breakpoints",
    timestamp: "2026-01-20 11:15",
  },
  {
    id: 3,
    ticketId: 1,
    author: "Seif Sameh",
    message: "Fixed and deployed to staging for testing",
    timestamp: "2026-01-20 15:45",
  },
];

export const chatMessages = [
  {
    id: 1,
    user: "Mohamed Osman",
    message: "Good morning team! Quick standup at 10 AM",
    timestamp: "2026-01-25 09:15",
    avatar: "👨‍💻",
  },
  {
    id: 2,
    user: "Seif Sameh",
    message: "Sure, I will join",
    timestamp: "2026-01-25 09:17",
    avatar: "👨‍💼",
  },
  {
    id: 3,
    user: "Ammar Moataz",
    message: "Can someone review my PR for the new dashboard?",
    timestamp: "2026-01-25 09:20",
    avatar: "👨‍🎨",
  },
  {
    id: 4,
    user: "Mariam Mostafa",
    message: "I will review it after the standup",
    timestamp: "2026-01-25 09:22",
    avatar: "👩‍💻",
  },
];

export const channels = [
  {
    id: 1,
    name: "general",
    displayName: "General",
    description: "Team-wide announcements and general discussion",
    members: [1, 2, 3, 4, 5],
    messages: [
      {
        id: 1,
        user: "Mohamed Osman",
        message: "Good morning team! Quick standup at 10 AM",
        timestamp: "2026-01-25 09:15",
        avatar: "👨‍💻",
      },
      {
        id: 2,
        user: "Seif Sameh",
        message: "Sure, I will join",
        timestamp: "2026-01-25 09:17",
        avatar: "👨‍💼",
      },
      {
        id: 3,
        user: "Ammar Moataz",
        message: "Can someone review my PR for the new dashboard?",
        timestamp: "2026-01-25 09:20",
        avatar: "👨‍🎨",
      },
      {
        id: 4,
        user: "Mariam Mostafa",
        message: "I will review it after the standup",
        timestamp: "2026-01-25 09:22",
        avatar: "👩‍💻",
      },
    ],
    unreadCount: 0,
  },
  {
    id: 2,
    name: "frontend-team",
    displayName: "Frontend Team",
    description: "Frontend development discussions",
    members: [2, 3, 4],
    messages: [
      {
        id: 1,
        user: "Seif Sameh",
        message: "Let's discuss the new component library structure",
        timestamp: "2026-01-25 08:30",
        avatar: "👨‍💼",
      },
      {
        id: 2,
        user: "Ammar Moataz",
        message: "I think we should use Storybook for documentation",
        timestamp: "2026-01-25 08:35",
        avatar: "👨‍🎨",
      },
      {
        id: 3,
        user: "Mariam Mostafa",
        message: "Great idea! I'll set it up",
        timestamp: "2026-01-25 08:40",
        avatar: "👩‍💻",
      },
    ],
    unreadCount: 2,
  },
  {
    id: 3,
    name: "backend-team",
    displayName: "Backend Team",
    description: "Backend API and database discussions",
    members: [1, 5],
    messages: [
      {
        id: 1,
        user: "Mohamed Osman",
        message: "The new authentication middleware is ready for review",
        timestamp: "2026-01-25 10:00",
        avatar: "👨‍💻",
      },
      {
        id: 2,
        user: "Youssef Alaa",
        message: "I'll test it with the new endpoints",
        timestamp: "2026-01-25 10:15",
        avatar: "👨‍🔧",
      },
      {
        id: 3,
        user: "Mohamed Osman",
        message: "Perfect! Let me know if you find any issues",
        timestamp: "2026-01-25 10:20",
        avatar: "👨‍💻",
      },
    ],
    unreadCount: 0,
  },
  {
    id: 4,
    name: "project-alpha",
    displayName: "Project Alpha",
    description: "Project Alpha development updates",
    members: [1, 2, 3, 4, 5],
    messages: [
      {
        id: 1,
        user: "Seif Sameh",
        message: "The frontend is 80% complete",
        timestamp: "2026-01-24 16:00",
        avatar: "👨‍💼",
      },
      {
        id: 2,
        user: "Mohamed Osman",
        message: "Backend APIs are ready for integration",
        timestamp: "2026-01-24 16:30",
        avatar: "👨‍💻",
      },
      {
        id: 3,
        user: "Ammar Moataz",
        message: "UI/UX designs are finalized",
        timestamp: "2026-01-24 17:00",
        avatar: "👨‍🎨",
      },
    ],
    unreadCount: 5,
  },
  {
    id: 5,
    name: "random",
    displayName: "Random",
    description: "Non-work banter and water cooler chat",
    members: [1, 2, 3, 4, 5],
    messages: [
      {
        id: 1,
        user: "Mariam Mostafa",
        message: "Anyone up for lunch?",
        timestamp: "2026-01-25 12:00",
        avatar: "👩‍💻",
      },
      {
        id: 2,
        user: "Youssef Alaa",
        message: "I'm in!",
        timestamp: "2026-01-25 12:05",
        avatar: "👨‍🔧",
      },
    ],
    unreadCount: 0,
  },
];

export const kanbanTasks = {
  backlog: [
    {
      id: 1,
      title: "Design new landing page",
      description: "Create wireframes and mockups for the new landing page",
      assignee: "UI/UX Team",
      priority: "high",
      dueDate: "2026-02-01",
      labels: ["Design", "Frontend"],
    },
    {
      id: 2,
      title: "Implement authentication API",
      description: "Build JWT-based authentication endpoints",
      assignee: "Mohamed Osman",
      priority: "critical",
      dueDate: "2026-01-28",
      labels: ["Backend", "Security"],
    },
  ],
  todo: [
    {
      id: 3,
      title: "Build employee dashboard",
      description: "Create the main dashboard with stats and charts",
      assignee: "Seif Sameh",
      priority: "high",
      dueDate: "2026-01-30",
      labels: ["Frontend", "Dashboard"],
    },
  ],
  "in-progress": [
    {
      id: 4,
      title: "Optimize database queries",
      description: "Improve performance of employee search queries",
      assignee: "Youssef Alaa",
      priority: "medium",
      dueDate: "2026-02-05",
      labels: ["Backend", "Performance"],
    },
  ],
  "wait-review": [
    {
      id: 5,
      title: "Mobile app testing",
      description: "Test new features on iOS and Android",
      assignee: "Mariam Mostafa",
      priority: "high",
      dueDate: "2026-01-27",
      labels: ["Mobile", "Testing"],
    },
  ],
  "in-review": [
    {
      id: 6,
      title: "Code review for PR #123",
      description: "Review authentication module changes",
      assignee: "Ammar Moataz",
      priority: "medium",
      dueDate: "2026-01-26",
      labels: ["Code Review"],
    },
  ],
  qa: [
    {
      id: 7,
      title: "Test payment integration",
      description: "Verify payment gateway integration works correctly",
      assignee: "QA Team",
      priority: "critical",
      dueDate: "2026-01-29",
      labels: ["Testing", "Payment"],
    },
  ],
  done: [
    {
      id: 8,
      title: "Setup CI/CD pipeline",
      description: "Configure GitHub Actions for automated deployments",
      assignee: "DevOps Team",
      priority: "high",
      dueDate: "2026-01-25",
      labels: ["DevOps", "Automation"],
    },
  ],
};

export const userProfile = {
  id: 1,
  fullName: "Adham Ahmed",
  nickname: "Admin",
  email: "adham@absisgy.com",
  phone: "01234567890",
  role: "Administrator",
  department: "IT",
  avatar: "👨‍💼",
  joinedDate: "2024-01-15",
  bio: "Full-stack developer and team lead",
};

export const requests = [
  {
    id: 1,
    employee: "Mohamed Osman",
    type: "Time Off",
    reason: "Medical appointment",
    startDate: "2026-02-01",
    endDate: "2026-02-01",
    status: "pending",
    submittedAt: "2026-01-25 09:30",
  },
  {
    id: 2,
    employee: "Seif Sameh",
    type: "Remote Work",
    reason: "Family emergency",
    startDate: "2026-01-27",
    endDate: "2026-01-29",
    status: "approved",
    submittedAt: "2026-01-24 14:20",
  },
  {
    id: 3,
    employee: "Ammar Moataz",
    type: "Time Off",
    reason: "Personal matter",
    startDate: "2026-02-05",
    endDate: "2026-02-07",
    status: "rejected",
    submittedAt: "2026-01-23 11:15",
  },
];

export const notifications = [
  {
    id: 1,
    type: "task",
    title: "New task assigned to you",
    message:
      'You have been assigned to "Update Dashboard UI" in the Frontend Board',
    time: "5 minutes ago",
    unread: true,
    actionUrl: "/boards/frontend",
  },
  {
    id: 2,
    type: "team",
    title: "New team member joined",
    message: "Nouran Khaled has joined the Frontend Development team",
    time: "2 hours ago",
    unread: true,
    actionUrl: "/employees",
  },
  {
    id: 3,
    type: "success",
    title: "Task completed successfully",
    message: 'Mohamed Osman completed "API Integration" in Backend Board',
    time: "5 hours ago",
    unread: false,
    actionUrl: "/boards/backend",
  },
  {
    id: 4,
    type: "meeting",
    title: "Upcoming team meeting",
    message: "Sprint planning meeting starts in 30 minutes at 2:00 PM",
    time: "Today at 1:30 PM",
    unread: false,
    actionUrl: "/main/dashboard",
  },
  {
    id: 5,
    type: "alert",
    title: "Project deadline approaching",
    message: "Mobile App Release v2.0 milestone is due in 3 days",
    time: "Yesterday at 10:00 AM",
    unread: false,
    actionUrl: "/boards/mobile",
  },
  {
    id: 6,
    type: "message",
    title: "New message from HR",
    message: "Your monthly report has been reviewed and approved",
    time: "2 days ago",
    unread: false,
    actionUrl: "/management/monthly-report",
  },
  {
    id: 7,
    type: "ticket",
    title: "Support ticket assigned",
    message:
      'High priority ticket "Login page not responsive" needs your attention',
    time: "3 days ago",
    unread: false,
    actionUrl: "/tickets",
  },
  {
    id: 8,
    type: "success",
    title: "Code review approved",
    message: "Seif Sameh approved your pull request #PR-145",
    time: "4 days ago",
    unread: false,
    actionUrl: "/boards/frontend",
  },
  {
    id: 9,
    type: "request",
    title: "Time-off request pending",
    message: "Ammar Moataz submitted a remote work request for Jan 30-31",
    time: "5 days ago",
    unread: false,
    actionUrl: "/requests",
  },
  {
    id: 10,
    type: "system",
    title: "System maintenance scheduled",
    message:
      "The portal will undergo maintenance on Feb 1st from 2:00 AM to 4:00 AM",
    time: "1 week ago",
    unread: false,
    actionUrl: "/main/dashboard",
  },
];
